import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionDetailPage } from 'src/pages/billing/subscription-detail';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { AuthGuard } from '@onesource/components';

export const Route = createFileRoute('/subscriptions/$subscriptionNo')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <SubscriptionDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
